import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_EMPLOYMENT,
  EMPLOYMENT_CHANGED,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_EMPLOYMENTS_FAILURE,
  UPDATE_EMPLOYMENTS_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

const byId = (state = {}, {type, payload}) => {
  let isPrimary = true;
  let employment, secondaryEmployment = null;
  let flowState = 'employment'
  if (payload && payload.employment) {
    flowState = payload.loanApplicationUser.flowState
    employment = payload.employment;
    secondaryEmployment = payload.secondaryEmployment
  }

  if (payload && payload.applicationFlow && payload.applicationFlow.employment) {
    flowState = payload.applicationFlow.loanApplicationUser.flowState
    employment = payload.applicationFlow.employment;
    secondaryEmployment = payload.applicationFlow.secondaryEmployment
  }

  isPrimary = flowState === 'employment'

  switch (type) {
    case UPDATE_EMPLOYMENTS_SUCCESS:
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (employment || secondaryEmployment) {
        return isPrimary ? employment : secondaryEmployment
      }

      return state
    case EMPLOYMENT_CHANGED:
      const { key } = payload
      const updatedEmployment = {...state[key], ...payload }
      updatedEmployment.errors = null;
      return { ...state, [key]: updatedEmployment }
    case BUILD_EMPLOYMENT:
      return {
        ...state,
        [payload.key]: { ...payload.data, errors: {} }
      }
    case UPDATE_EMPLOYMENTS_FAILURE:
      return payload.entities || {}
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
      if (payload.employment !== undefined) {
        return isPrimary ? employment : secondaryEmployment
      }

      return state
    default:
      return state;
  }
}

export default byId;
